import { render, staticRenderFns } from "./LegacyImportationTable.vue?vue&type=template&id=2045fdd1"
import script from "./LegacyImportationTable.vue?vue&type=script&lang=js"
export * from "./LegacyImportationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports